import React from "react";
import { Dialog, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ImageModal = ({ open, image, onClose }) => {
  if (!image) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          background: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 1,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "#fff",
            background: "rgba(0,0,0,0.6)",
            "&:hover": {
              background: "rgba(0,0,0,0.8)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Image */}
        <Box
          component="img"
          src={image}
          alt="Preview"
          sx={{
            width: "90vw",
            maxHeight: "90vh",
            objectFit: "contain",
            borderRadius: 2,
            boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
          }}
        />
      </Box>
    </Dialog>
  );
};

export default ImageModal;